import React from 'react';
import { Chip } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { ENV_CONFIG } from '../config/env';

/**
 * Red "TEST INSTANCE" label shown only when the admin panel is pointed at the
 * Sankalp test backend (see ENV_CONFIG.IS_TEST_INSTANCE). Renders nothing on
 * production so it's a safe drop-in anywhere.
 */
const TestInstanceBadge: React.FC<{ size?: 'small' | 'medium' }> = ({ size = 'small' }) => {
  if (!ENV_CONFIG.IS_TEST_INSTANCE) return null;

  return (
    <Chip
      icon={<ScienceOutlinedIcon sx={{ color: '#ffffff !important' }} />}
      label="TEST INSTANCE"
      size={size}
      sx={{
        backgroundColor: '#d32f2f',
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: '0.5px',
        borderRadius: 1.5,
      }}
    />
  );
};

export default TestInstanceBadge;
